import axios from "axios";

let originalBaseUrl = process.env.REACT_APP_DEV_API_BASE_URL 
  || "https://swiftapprove-backend-9402cfc7ddaa.herokuapp.com/";
let overrideBaseUrl = null;

function applyBaseUrl() {
  axios.defaults.baseURL = overrideBaseUrl || originalBaseUrl;
  console.log("[API Manager] axios baseURL →", axios.defaults.baseURL);
}

export function testApi(url) {
  overrideBaseUrl = url;
  applyBaseUrl();
}

export function cancelApi() {
  overrideBaseUrl = null;
  applyBaseUrl();
}

export function getApiUrl() {
  return overrideBaseUrl || originalBaseUrl;
}

// Attach the logged-in user's Firebase UID to admin (backoffice) requests so
// the backend can verify the caller against the backoffice allowlist. The user
// is persisted by recoil-persist under localStorage 'recoil-persist'.
axios.interceptors.request.use((config) => {
  try {
    const url = config.url || "";
    if (url.includes("/api/admin")) {
      const persisted = JSON.parse(localStorage.getItem("recoil-persist") || "{}");
      const uid = persisted?.user?.firebaseAuthUUID;
      if (uid) {
        config.params = { ...(config.params || {}), firebaseAuthUUID: uid };
      }
    }
  } catch (e) {
    // ignore — request proceeds without the uid and the backend will 401
  }
  return config;
});

// initialize on load
applyBaseUrl();
